<template>
  <base-interest-indicator-card
    label="Video Views"
    :value="value"
  ></base-interest-indicator-card>
</template>
<script>
import BaseInterestIndicatorCard from './BaseInterestIndicatorCard.vue';
export default {
  props: {
    value: [String, Number],
  },
  components: {
    BaseInterestIndicatorCard,
  },
};
</script>
